import LegalPage from "@/components/LegalPage";
import { IMPRESSUM, SITE } from "@/data/site";

export default function Datenschutz() {
  return (
    <LegalPage title="Datenschutzerklärung" testid="datenschutz-page">
      <h2>1. Verantwortliche Stelle</h2>
      <p>
        Verantwortlich für die Datenverarbeitung auf dieser Website ist:
        <br />
        <strong>{IMPRESSUM.name}</strong>, Deutschland · Telefon/WhatsApp:{' '}
        {SITE.phoneDisplay} · E-Mail: {IMPRESSUM.email}
      </p>

      <h2>2. Besuch der Website</h2>
      <p>
        Beim Aufruf der Seite verarbeitet das Hosting-System automatisch technische
        Zugriffsdaten (IP-Adresse, Datum und Uhrzeit, aufgerufene Seite, Browsertyp).
        Diese Daten sind technisch notwendig, um die Seite auszuliefern und ihre
        Sicherheit zu gewährleisten (Art. 6 Abs. 1 lit. f DSGVO). Es findet{' '}
        <strong>kein Tracking und keine Werbe-Cookies</strong> statt.
      </p>

      <h2>3. Kontakt über WhatsApp oder Telefon</h2>
      <p>
        Wenn du uns über WhatsApp, telefonisch oder über die Buttons auf der Seite
        kontaktierst, verarbeiten wir deine dort angegebenen Daten (z. B. Name,
        Rufnummer, Nachrichteninhalt) ausschließlich zur Bearbeitung deiner Anfrage
        (Art. 6 Abs. 1 lit. b DSGVO).
      </p>
      <p>
        <strong>WhatsApp:</strong> Die Kommunikation läuft über WhatsApp, betrieben
        von Meta Platforms Ireland Ltd. Es gelten die WhatsApp-Datenschutzhinweise
        (www.whatsapp.com/legal). Bitte teile uns über WhatsApp keine besonders
        sensiblen Daten mit.
      </p>

      <h2>4. Kauf und Zahlung über Stripe</h2>
      <p>
        Beim Kauf über die Kreditkarte läuft die Abwicklung über{' '}
        <strong>Stripe Payments Europe Ltd.</strong>, 1 Grand Canal Street Lower,
        Dublin 2, Irland. Dabei verarbeitet Stripe insbesondere Name, E-Mail-Adresse,
        Versandadresse und Zahlungsdaten. Wir selbst erhalten von Stripe nur den Namen
        des bestellten Stücks, deine E-Mail-Adresse und die Versandadresse —{' '}
        <strong>keine Kreditkartendaten</strong> (Art. 6 Abs. 1 lit. b DSGVO). Es
        gelten die Datenschutzhinweise von Stripe (stripe.com/privacy).
      </p>

      <h2>5. Bestätigungs-E-Mail</h2>
        <p>
        Nach erfolgreichem Kauf senden wir dir automatisch eine Bestätigungs-E-Mail an
        die bei der Zahlung angegebene Adresse (Art. 6 Abs. 1 lit. b DSGVO). Der
        Versand erfolgt über einen technischen Versanddienst im Auftrag der
        verantwortlichen Stelle.
      </p>

      <h2>6. Speicherdauer</h2>
      <p>
        Bestell- und Zahlungsdaten speichern wir, soweit handels- und steuerrechtliche
        Aufbewahrungspflichten bestehen (in der Regel 10 Jahre), und löschen sie
        danach. Anfragedaten löschen wir, wenn sie nicht mehr benötigt werden.
      </p>

      <h2>7. Deine Rechte</h2>
      <p>
        Du hast jederzeit das Recht auf <strong>Auskunft</strong> (Art. 15),
        <strong> Berichtigung</strong> (Art. 16), <strong>Löschung</strong> (Art. 17),
        <strong> Einschränkung der Verarbeitung</strong> (Art. 18),
        <strong> Datenübertragbarkeit</strong> (Art. 20) sowie{' '}
        <strong>Widerspruch</strong> (Art. 21 DSGVO). Wende dich dazu einfach per
        WhatsApp oder an die oben genannten Kontaktdaten.
      </p>
      <p>
        Zudem hast du das Recht, dich bei einer Datenschutzaufsichtsbehörde zu
        beschweren (Art. 77 DSGVO).
      </p>

      <h2>8. Datensicherheit</h2>
      <p>
        Diese Seite nutzt durchgängig eine TLS-Verschlüsselung. Zahlungen werden
        ausschließlich über den zertifizierten Zahlungsdienstleister Stripe
        abgewickelt.
      </p>
    </LegalPage>
  );
}
